<template>
  <div class="field clinic-multi-field">
    <label class="field-lbl">
      สาขา
      <span v-if="value.length" class="clinic-multi-count">
        · {{ value.length }} สาขา ·
        <button type="button" class="clinic-multi-clear" data-testid="branch-filter-clear" @click="clear">
          ล้าง
        </button>
      </span>
    </label>
    <multiselect
      class="multiselect-h-36px clinic-multi"
      data-testid="branch-filter"
      :value="selectedOptions"
      :options="options"
      :multiple="true"
      :close-on-select="false"
      :hide-selected="true"
      track-by="value"
      label="text"
      :placeholder="value.length ? 'เพิ่มสาขา…' : 'ทุกสาขา · พิมพ์เพื่อเลือกบางสาขา'"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @input="onInput"
    >
      <span slot="noResult">ไม่พบสาขา กรุณาเปลี่ยนคำค้นหา</span>
      <span slot="noOptions">ยังไม่มีสาขาให้เลือก กด "แสดงข้อมูล" ก่อน</span>
    </multiselect>
  </div>
</template>

<script>
// Multi-branch picker for the clinic-level reports. v-model is an array of option
// values; an empty array means every branch.
export default {
  name: "ClinicBranchMultiSelect",
  props: {
    value: { type: Array, default: () => [] },
    // [{ value, text }]
    options: { type: Array, default: () => [] },
  },
  computed: {
    // A selected branch can be missing from `options` (it had no rows in the new date
    // range, or it was picked on another tab). Keep it visible as a chip so the user can
    // see — and remove — the filter that is still being applied.
    selectedOptions() {
      return this.value.map(
        v => this.options.find(o => o.value === v) || { value: v, text: String(v) }
      );
    },
  },
  methods: {
    onInput(opts) {
      this.$emit("input", (opts || []).map(o => o.value));
    },
    clear() {
      this.$emit("input", []);
    },
  },
};
</script>

<style>
.clinic-multi-count {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}
.clinic-multi-clear {
  border: 0;
  background: none;
  padding: 0;
  color: #1f6feb;
  font: inherit;
  cursor: pointer;
}
.clinic-multi-clear:hover {
  text-decoration: underline;
}
</style>
